import React, { useState } from "react";
import { EyeIcon, EyeOffIcon } from "../../../components/common/Icons/Icons";

interface PasswordInputProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: "current-password" | "new-password" | "off";
  required?: boolean;
  disabled?: boolean;
}

/** Password field with a show / hide toggle sitting inside it. */
const PasswordInput: React.FC<PasswordInputProps> = ({
  id,
  name,
  value,
  onChange,
  autoComplete,
  required = false,
  disabled = false,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="auth-password">
      <input
        id={id}
        name={name}
        className="input"
        type={visible ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
      />
      <button
        type="button"
        className="auth-eye"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        tabIndex={-1}
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
};

export default PasswordInput;
